export default "__VITE_PUBLIC_ASSET__6e2a1fe2__"